export default [
    {
        id: 1,
        name_ca: 'Desconeguda',
        name_es: 'Desconocida',
        name_en: 'Unknown'
    }, {
        id: 2,
        name_ca: 'Cap',
        name_es: 'Ninguno',
        name_en: 'None'
    }, {
        id: 39,
        name_ca: 'Parquet',
        name_es: 'Parquet',
        name_en: 'Parquet'
    }, {
        id: 3,
        name_ca: 'Parquet de fusta natural',
        name_es: 'Parquet de madera natural',
        name_en: 'Natural wood flooring'
    }, {
        id: 4,
        name_ca: 'Parquet sintètic',
        name_es: 'Parquet sintétco',
        name_en: 'Synthetic wood flooring'
    }, {
        id: 5,
        name_ca: 'Terratzo continu',
        name_es: 'Terrazo continuo',
        name_en: 'Continuous terrazzo'
    }, {
        id: 6,
        name_ca: 'Rajoles de terratzo',
        name_es: 'Baldosas de terrazo',
        name_en: 'Terrazo tiles'
    }, {
        id: 7,
        name_ca: 'Rajola ceràmica',
        name_es: 'Baldosa cerámica',
        name_en: 'Ceramic tile'
    }, {
        id: 8,
        name_ca: 'Rajola de gres extruït esmaltat',
        name_es: 'Baldosa de gres extruido esmaltado',
        name_en: 'Glazed extruded stoneware tile'
    }, {
        id: 9,
        name_ca: 'Rajola de gres extruït sense esmaltar',
        name_es: 'Baldosa de gres extruido sin esmaltar',
        name_en: 'Unglazed extruded stoneware tile'
    }, {
        id: 10,
        name_ca: 'Rajola de gres porcelànic',
        name_es: 'Baldosa de gres porcelánico',
        name_en: 'Porcelain stoneware tile'
    }, {
        id: 11,
        name_ca: 'Rajola de gres premsat esmaltat',
        name_es: 'Baldosa de gres prensado esmaltado',
        name_en: 'Pressed glazed stoneware tile'
    }, {
        id: 12,
        name_ca: 'Rajola hidràulica',
        name_es: 'Baldosa hidráulica',
        name_en: 'Hydraulic tile'
    }, {
        id: 13,
        name_ca: 'Panot',
        name_es: 'Panot',
        name_en: 'Panot'
    }, {
        id: 14,
        name_ca: 'Rajola de gres',
        name_es: 'Baldosa de gres',
        name_en: 'Stoneware tile'
    }, {
        id: 15,
        name_ca: 'Formigó',
        name_es: 'Hormigón',
        name_en: 'Concrete'
    }, {
        id: 16,
        name_ca: 'Peces de formigó',
        name_es: 'Piezas de hormigón',
        name_en: 'Concrete pieces'
    }, {
        id: 17,
        name_ca: 'Microciment',
        name_es: 'Microcemeento',
        name_en: 'Microcement'
    }, {
        id: 18,
        name_ca: 'Morter continu',
        name_es: 'Mortero continuo',
        name_en: 'Continous mortar'
    }, {
        id: 19,
        name_ca: 'Llosetes de suro',
        name_es: 'Losetas de corcho',
        name_en: 'Cork tiles'
    }, {
        id: 20,
        name_ca: 'Continu de resines',
        name_es: 'Continuo de resinas',
        name_en: 'Continuous resin'
    }, {
        id: 21,
        name_ca: 'Linoleum',
        name_es: 'Linoleum',
        name_en: 'Linoleum'
    }, {
        id: 22,
        name_ca: 'Goma bicapa',
        name_es: 'Goma bicapa',
        name_en: 'Bilayer rubber'
    }, {
        id: 23,
        name_ca: 'Cautxú reciclat',
        name_es: 'Caucho reciclado',
        name_en: 'Recycled rubber'
    }, {
        id: 24,
        name_ca: 'Flotant de pvc',
        name_es: 'Flotante de pvc',
        name_en: 'Floating pvc'
    }, {
        id: 25,
        name_ca: 'Entramat sintètic',
        name_es: 'Entramado sintético',
        name_en: 'Synthetic fabric'
    }, {
        id: 26,
        name_ca: 'PVC homogeni',
        name_es: 'PVC homogéneo',
        name_en: 'Homogeneous PVC'
    }, {
        id: 27,
        name_ca: 'PVC heterogeni',
        name_es: 'PVC heterogéneo',
        name_en: 'Heterogeneous PVC'
    }, {
        id: 28,
        name_ca: 'Composite de fusta i plàstic',
        name_es: 'Composite de madera y plástico',
        name_en: 'Wood and plastic composite'
    }, {
        id: 29,
        name_ca: 'Moqueta de llana',
        name_es: 'Moqueta de lana',
        name_en: 'Wool carpet'
    }, {
        id: 30,
        name_ca: 'Moqueta de fibres sintètiques',
        name_es: 'Moqueta de fibras sintéticas',
        name_en: 'Carpet fibers'
    }, {
        id: 31,
        name_ca: 'Entramat metàl·lic',
        name_es: 'Entramado metálico',
        name_en: 'Metal lattice'
    }, {
        id: 32,
        name_ca: 'Planxa d\'acer galvanitzat',
        name_es: 'Plancha de acero galvanizado',
        name_en: 'Galvanized steel plate'
    }, {
        id: 33,
        name_ca: 'Paviment tècnic per a interiors',
        name_es: 'Pavimento técnico para interiores',
        name_en: 'Technical flooring'
    }, {
        id: 34,
        name_ca: 'Pedra natural',
        name_es: 'Piedra natural',
        name_en: 'Natural stone'
    }, {
        id: 35,
        name_ca: 'Marbre',
        name_es: 'Mármol',
        name_en: 'Marble'
    }, {
        id: 36,
        name_ca: 'Granit',
        name_es: 'Granito',
        name_en: 'Granite'
    }, {
        id: 37,
        name_ca: 'Pissarra',
        name_es: 'Pizarra',
        name_en: 'Slate'
    }, {
        id: 38,
        name_ca: 'Rajola ceràmica vermella',
        name_es: 'Baldosa cerámica roja',
        name_en: 'Red ceramic tile'
    }, {
        id: 40,
        name_ca: 'Gresite',
        name_es: 'Gresite',
        name_en: 'Gresite'
    }
]





// WEBPACK FOOTER //
// ./src/options/pavings.js